import { FormControl, InputLabel, Select, SelectProps, Typography } from "@mui/material";
import { useId } from "react";
const LabeledSelect = ({ sx, label, value, required, fullWidth, children, ...props }: SelectProps<string>) => {
  const id = useId();
  return <FormControl sx={{
    width: fullWidth ? "100%" : undefined,
    ...sx,
  }}>
    <InputLabel id={id} size="small">{label}{(required && !value) && <Typography color="error" component="span"> *</Typography>}</InputLabel>
    <Select
      {...props}
      labelId={id}
      label={`${label}${value ? '' : ' *'}`}
      value={value}
    >
      {children}
    </Select>
  </FormControl>
}

export default LabeledSelect;
